'use client';

import { Select, TextInput, Button } from '@mantine/core';
import { useState, useEffect } from 'react';
import fr from '@/src/dictionaries/fr.json';

const allPages = { fr };

export const LinkFieldInput = ({
  value,
  onChange,
  lang,
}: {
  value: string;
  onChange: (val: string) => void;
  lang: 'fr';
}) => {
  const [mode, setMode] = useState(
    value.startsWith('/') && !value.startsWith('http') ? 'select' : 'custom'
  );

  // Internal synced state for live preview
  const [localValue, setLocalValue] = useState(value);

  // Sync internal value if parent updates it
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const pageData = allPages[lang]?.pages ?? {};

  const options = Object.entries(pageData).map(([key, page]: any) => {
    const label = page?.title || page?.label || key;
    const route = key === 'home' ? '/' : `/${key}`;

    return {
      value: route,
      label: `${label} (${route})`,
    };
  });

  return mode === 'select' ? (
    <>
      <Select
        label="Page liée"
        placeholder="Sélectionnez une page"
        searchable
        data={[...options, { value: 'custom', label: '🔗 Ajouter un lien personnalisé' }]}
        value={localValue}
        onChange={(val) => {
          if (val === 'custom') {
            setMode('custom');
          } else if (val) {
            setLocalValue(val);
            onChange(val);
          }
        }}
      />
      <TextInput
        label="Prévisualisation"
        disabled
        value={localValue}
        mt="sm"
      />
    </>
  ) : (
    <>
      <TextInput
        label="Lien personnalisé"
        placeholder="ex: /mon-service ou https://autresite.com"
        value={localValue}
        onChange={(e) => {
          const val = e.currentTarget.value;
          setLocalValue(val);
          onChange(val);
        }}
      />
      <Button
        variant="light"
        color="gray"
        size="xs"
        mt="xs"
        onClick={() => setMode('select')}
      >
        ⬅️ Retour à la liste des pages
      </Button>
    </>
  );
};
